import gsap from 'gsap';

class Search {
    constructor() {
        this.trigger = '.search__trigger';
        this.close = '.search__close';
        this.search = '.search__fullscreen';
        this.input = document.querySelector('.orig');

        this.init();
    }

    init() {
        const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        const triggers = document.querySelectorAll(this.trigger);
        if (triggers) {
            triggers.forEach((trigger) => {
                trigger.addEventListener('click', (e) => {
                    console.log('search');
                    e.preventDefault();
                    this.openSearch();
                });
            });
        }

        const close = document.querySelector(this.close);
        if (close) {
            close.addEventListener('click', () => {
                this.closeSearch();
            });
        }
    }

    openSearch() {
        const tl = gsap.timeline();
        const search = document.querySelector(this.search);
        const container = document.querySelector('.search__container');
        const close = document.querySelector(this.close);
        const body = document.querySelector('body');

        if (search) {
            tl
                .set(search, { top: 0 })
                .to(search, { duration: 0.4, opacity: 1 })
                .to(body, { duration: 0.4, overflow: 'hidden' })
                .to(container, { duration: 0.6, opacity: 1 }, '-=0.1')
                .to(close, { duration: 0.4, opacity: 1 }, '-=0.2');
        }
    }

    closeSearch() {
        const tl = gsap.timeline();
        const search = document.querySelector(this.search);
        const container = document.querySelector('.search__container');
        const close = document.querySelector(this.close);
        const body = document.querySelector('body');

        if (search) {
            tl
                .to(container, 0.4, { opacity: 0 })
                .to(close, 0.4, { opacity: 0 }, '-=0.2')
                .to(body, 0.4, { overflow: 'visible' })
                .to(search, 0.4, { opacity: 0 }, '-=0.2')
                .set(search, { top: '-110vh' });
        }
    }
}

export default Search;
